import { FC, MouseEvent, ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { Link, Tile } from '@digital-pulse/react';
import { URL_PREFIX } from '@/lib/constants';
import { AppEnvName, getEnvName } from '@cvs-web/splash-components';

import styles from './preference-tile.module.scss';
import { triggerLinkTag } from '@/lib/utils/adobeTagging';

interface Props {
  icon?: ReactNode;
  label: ReactNode;
  href?: string;
  route?: string;
  description?: ReactNode;
  linkTag?: string;
  onClick?: () => void;
}

const PreferenceTile: FC<Props> = ({ icon, label, href, route, description, linkTag, onClick }): ReactNode => {
  const router = useRouter();
  const urlPrefix = getEnvName() !== AppEnvName.local ? URL_PREFIX : '';

  const handleClick = (ev: MouseEvent): void => {
    if (route) {
      if (linkTag) {
        triggerLinkTag(linkTag);
      }
      ev.preventDefault();
      router.push(route);
    }
    onClick?.();
  };

  return (
    <Tile className={styles.preferenceTile} onClick={handleClick}>
      <div className={styles.container}>
        <div className={styles.content}>
          <Link
            variant="standalone"
            onClick={handleClick}
            href={href || urlPrefix + route}
            renderLeading={icon ? <div>{icon}</div> : undefined}
            className={description ? styles.prefLinkWithTag : styles.prefLink}
          >
            {label}
          </Link>
          {description && <div className={styles.description}>{description}</div>}
        </div>
      </div>
    </Tile>
  );
};

export default PreferenceTile;
